import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-DN7d1SzH.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../index-B0Q3DaKR.js';
import { _ as _createClass, a as _classCallCheck } from '../../createClass-DV1OmW3s.js';
import { _ as _defineProperty } from '../../defineProperty-DmV7cVMj.js';
import fetch from 'isomorphic-fetch';
import getDeviceId from '../../getDeviceId/index.js';
import IS_BROWSER from '../../isBrowser/index.js';

var _excluded = ["withoutLanguageHeader"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HttpService = /*#__PURE__*/function () {
  function HttpService() {
    _classCallCheck(this, HttpService);
  }
  return _createClass(HttpService, null, [{
    key: "modifiedFetch",
    value: function () {
      var _modifiedFetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
        var options,
          response,
          contentType,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return fetch(url, options);
            case 3:
              response = _context.sent;
              if (!(response.status < 200 || response.status >= 300)) {
                _context.next = 6;
                break;
              }
              throw response;
            case 6:
              contentType = response.headers.get('content-type');
              return _context.abrupt("return", contentType !== null && contentType !== undefined && contentType.includes('application/json') ? response.json() : {});
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function modifiedFetch(_x) {
        return _modifiedFetch.apply(this, arguments);
      }
      return modifiedFetch;
    }()
  }, {
    key: "attachInterceptor",
    value: function attachInterceptor(customFetch, requestUrl) {
      var requestOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var skipInterceptors = requestOptions.skipInterceptors;
      if (skipInterceptors || !HttpService.interceptors.length) {
        return customFetch(requestUrl, requestOptions);
      }
      var reversedInterceptors = HttpService.interceptors.reverse();
      var promise = Promise.resolve({
        url: requestUrl,
        options: requestOptions
      });

      // Register request interceptors
      reversedInterceptors.forEach(function (_ref) {
        var request = _ref.request,
          requestError = _ref.requestError;
        if (request || requestError) {
          promise = promise.then(request && function (_ref2) {
            var url = _ref2.url,
              options = _ref2.options;
            return request(url, options);
          }, requestError);
        }
      });

      // Register fetch call
      promise = promise.then(function (_ref3) {
        var url = _ref3.url,
          options = _ref3.options;
        return customFetch(url, options);
      });

      // Register response interceptors
      reversedInterceptors.forEach(function (_ref4) {
        var response = _ref4.response,
          responseError = _ref4.responseError;
        if (response || responseError) {
          promise = promise.then(response, responseError);
        }
      });
      return promise;
    }
  }, {
    key: "registerInterceptor",
    value: function registerInterceptor(interceptor) {
      HttpService.interceptors.push(interceptor);
      return function () {
        HttpService.interceptors = HttpService.interceptors.filter(function (item) {
          return item !== interceptor;
        });
      };
    }
  }, {
    key: "clearInterceptors",
    value: function clearInterceptors() {
      HttpService.interceptors = [];
    }
  }, {
    key: "setConfig",
    value: function setConfig(config) {
      HttpService.config = _objectSpread(_objectSpread({}, HttpService.config), config);
      return HttpService;
    }
  }, {
    key: "getFormData",
    value: function getFormData(data) {
      if (IS_BROWSER && data instanceof FormData) {
        return data;
      }
      return JSON.stringify(data);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        withoutLanguageHeader = _ref5.withoutLanguageHeader,
        options = _objectWithoutProperties(_ref5, _excluded);
      var reqHeaders = _objectSpread({}, options.headers || {});
      var initialHeaders = _objectSpread({}, HttpService.options.headers);
      if (withoutLanguageHeader) {
        delete initialHeaders['language-code'];
      }
      if (IS_BROWSER && options.body instanceof FormData) {
        delete initialHeaders['Content-Type'];
      }
      var optionsHeaders = _objectSpread(_objectSpread({}, initialHeaders), reqHeaders);
      return _objectSpread(_objectSpread(_objectSpread({}, HttpService.options), options), {}, {
        headers: optionsHeaders
      });
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var headers = _objectSpread(_objectSpread({}, options.headers || {}), HttpService.options.headers);
      HttpService.options = _objectSpread(_objectSpread(_objectSpread({}, HttpService.options), options), {}, {
        headers: headers
      });
    }
  }, {
    key: "get",
    value: function get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var reqOptions = HttpService.getOptions(_objectSpread(_objectSpread({}, options), {}, {
        method: 'GET'
      }));
      return HttpService.fetch(url, reqOptions);
    }
  }, {
    key: "post",
    value: function post(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var reqOptions = HttpService.getOptions(_objectSpread(_objectSpread({}, options), {}, {
        method: 'POST',
        body: HttpService.getFormData(data)
      }));
      return HttpService.fetch(url, reqOptions);
    }
  }, {
    key: "put",
    value: function put(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var reqOptions = HttpService.getOptions(_objectSpread(_objectSpread({}, options), {}, {
        method: 'PUT',
        body: HttpService.getFormData(data)
      }));
      return HttpService.fetch(url, reqOptions);
    }
  }, {
    key: "delete",
    value: function _delete(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var reqOptions = HttpService.getOptions(_objectSpread(_objectSpread({}, options), {}, {
        method: 'DELETE',
        body: HttpService.getFormData(data)
      }));
      return HttpService.fetch(url, reqOptions);
    }
  }, {
    key: "fetch",
    value: function fetch(url, options) {
      return HttpService.attachInterceptor(HttpService.modifiedFetch, url, options);
    }
  }]);
}();
_defineProperty(HttpService, "config", {
  apiUrl: ''
});
_defineProperty(HttpService, "options", {
  headers: _objectSpread({
    'Content-Type': 'application/json'
  }, getDeviceId() && {
    deviceid: getDeviceId()
  })
});
_defineProperty(HttpService, "interceptors", []);

export { HttpService as default };
//# sourceMappingURL=index.js.map
